import { httpClient, apiLinks } from '@app/utils';
import {
  DataUsers,
  ParamsGetUsers,
  User,
  ModifyUser,
  ChangePasswordData,
} from '../models/user';

const getUsers = async (params: ParamsGetUsers): Promise<DataUsers> => {
  const response = await httpClient.get<DataUsers>({
    url: apiLinks.admin.userManagement.getSearch,
    params,
  });
  return response.data;
};

const getUsersBySearch = async (params: ParamsGetUsers): Promise<DataUsers> => {
  const result = await httpClient.get<DataUsers>({
    url: apiLinks.admin.userManagement.getSearch,
    params,
  });
  return result.data;
};

type CreateError<T> = {
  [P in keyof T]?: string[];
};

const createUser = async (data: ModifyUser): Promise<CreateError<void>> => {
  const result = await httpClient.post({
    url: apiLinks.admin.userManagement.createUser,
    data,
  });
  console.log(result);
};

const updateUser = async (id: string, data: ModifyUser): Promise<User> => {
  // try {
  const result = await httpClient.put({
    url: apiLinks.admin.userManagement.updateUser + `/${id}`,
    // params: { userId: data.userId },
    data: data,
  });
  console.log(result.data);
  return result.data as User;
};

const getUserDetail = async (userId: string): Promise<User> => {
  const result = await httpClient.get<User>({
    url: apiLinks.admin.userManagement.getUserDetail + `/${userId}`,
  });
  return result.data;
};

const resetPassword = async (userId: string): Promise<void> => {
  await httpClient.put({
    url: apiLinks.admin.userManagement.resetPassword,
    params: {
      userId: userId,
    },
  });
};

const changePassword = async (data: ChangePasswordData): Promise<string> => {
  const response = await httpClient.put<string>({
    url: apiLinks.admin.userManagement.changePassword,
    data,
  });

  return response.data;
};

const updateUserStatus = async (
  id: string,
  isActive: boolean,
): Promise<User> => {
  const response = await httpClient.put<User>({
    url: `${apiLinks.admin.userManagement.changeStatus}/${id}`,
    params: {
      isActive,
    },
  });

  return response.data;
};

// const searchTextUser = async (username: string, email: string, phoneNumber: string, fullName: string): Promise<DataTable> => {
//   const result = await httpClient.get({
//     url: apiLinks.csyt.userProfile.getAll + `/search`,
//     params: {
//       username, email, phoneNumber, fullName
//     }
//   });
//   return result.data as DataTable;
// };

// const updateStatusUser = async (id: string, status: number): Promise<void> => {
//   const result = await httpClient.put({
//     url: apiLinks.csyt.userProfile.update + `/${id}/Update`,
//     data: { status: status },
//   });
// };

const customerService = {
  getUsers,
  getUsersBySearch,
  updateUser,
  // updateStatusUser,
  getUserDetail,
  createUser,
  resetPassword,
  changePassword,
  updateUserStatus,
};

export default customerService;
